
import { axiosClientMiddleware } from "config/axios/AxiosClient";
import { AxiosResponse } from "axios";
import { CourierResponse } from "screens/ManageCoveragesScreen/types";

export const fetchCouriers = async (country: string, commune: string, token: string): Promise<any[]> => {
  try {
    const requestBody = {
      "skipRecords": 0,
      "maxRecords": 200,
      "project": [
        "id",
        "routeId",
        "deliveryType",
        "shippingType",
        "courierId"
      ],
      "filter": {
        "route": {
          "target": {
            "type": "Location",
            "data": {
              "criteria0": country.toUpperCase(),
              "criteria3": commune.toUpperCase()
            }
          }
        }
      }
    };

    const response: AxiosResponse<CourierResponse> = await axiosClientMiddleware.post(
      '/olm/routes/coverages/all',
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.data || response.data.code !== 200) {
      return [];
    }

    if (!response.data.message?.records) {
      return [];
    }

    return response.data.message.records.map(record => ({
      id: record.id,
      courierId: record.courierId, // Ensure courierId is passed
      name: record.courierId || record.id, // Use courierId as name if available, fallback to id
      alias: record.courierId,
      routeId: record.routeId,
      deliveryType: record.deliveryType,
      shippingType: record.shippingType,
      recordIds: [record.id] // Keep structure compatible
    }));


  } catch (error) {
    console.error('Error fetching couriers:', error);
    return [];
  }
};

export const fetchAllCouriers = async (token: string): Promise<any[]> => {
  try {
    const requestBody = {
      "skipRecords": 0,
      "maxRecords": 200
    };

    const response: AxiosResponse<any> = await axiosClientMiddleware.post(
      '/olm/couriers/all',
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.data || response.data.code !== 200) {
      return [];
    }

    if (!response.data.message?.records) {
      return [];
    }

    return response.data.message.records.map((record: any) => ({
      value: record.id,
      label: record.id
    }));

  } catch (error) {
    console.error('Error fetching all couriers:', error);
    return [];
  }
};
